import styled from 'styled-components';

export const Container = styled.div`
  .header-navigation-section-list,
  .header-navigation-section-link {
    display: flex;
    align-items: center;
  }

  .header-navigation-section-list {
    justify-content: space-between;
    color: var(--white);
    font-size: 0.9rem;
    font-weight: 700;
    padding: 1rem 0;
    white-space: nowrap;
    overflow-x: auto;
    user-select: none;

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }

    scrollbar-track-color: transparent;
    ::-webkit-scrollbar {
      height: 0.4rem;
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background: transparent;
    }

    scrollbar-base-color: transparent;
  }

  .header-navigation-section-link {
    padding: 0.8rem;
    gap: 0.4rem;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 0.4rem;

    &:hover {
      background-color: var(--gray_bold);
      opacity: 0.9;
    }

    .icon {
      width: 2rem;
      height: 2rem;
      color: var(--blue_light);
    }
  }

  @media (max-width: 1200px) {
    padding: 0 2rem;
  }

  @media (max-width: 1100px) {
    overflow: hidden;
    white-space: nowrap;

    .header-navigation-section-list {
      width: 100%;

      ::-webkit-scrollbar-track {
        background-color: transparent;
      }
      scroll-margin-left: 1rem;
      scrollbar-track-color: transparent;
      ::-webkit-scrollbar {
        height: 0.4rem;
        background: transparent;
      }

      ::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 1rem;
      }

      scrollbar-base-color: transparent;
    }
  }
`;
